import { Pipe, PipeTransform } from '@angular/core';
import { QuoteRequestField } from '../enums/quote-request-field';
import { CommodityType } from '../enums/commodity-type';

@Pipe({
  name: 'unitForCommodityFields',
})
export class UnitForCommodityFieldsPipe implements PipeTransform {
  transform(value: string, commodity: CommodityType, field: QuoteRequestField): any {
    if (commodity === CommodityType.Gas) return `${value} (${this.resolveGasFieldUnit(field)})`;

    if (commodity === CommodityType.Electricity) return `${value} (${this.resolveElectricFieldUnit(field)}}`;
  }

  resolveGasFieldUnit(fieldType: QuoteRequestField) {
    switch (fieldType) {
      case QuoteRequestField.BilledRate:
        return '$/ccf';
      case QuoteRequestField.CommissionRate:
        return 'cents/ccf';
      case QuoteRequestField.Volume:
        return 'ccf';
    }
  }

  resolveElectricFieldUnit(fieldType: QuoteRequestField) {
    switch (fieldType) {
      case QuoteRequestField.BilledRate:
        return '$/kWh';
      case QuoteRequestField.CommissionRate:
        return 'cents/kWh';
      case QuoteRequestField.Volume:
        return 'kWh';
    }
  }
}
